import { render, staticRenderFns } from "./DotMenuSeparator.vue?vue&type=template&id=a3fe0700&scoped=true&"
import script from "./DotMenuSeparator.vue?vue&type=script&lang=js&"
export * from "./DotMenuSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DotMenuSeparator.vue?vue&type=style&index=0&id=a3fe0700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fe0700",
  null
  
)

export default component.exports